/**
 * Single source of truth for vendor categories. Imported by admin (form +
 * CSV import), web (filter list + new-vendor form), and navigator (filter
 * list + new-vendor modal). When this list changes, every consumer picks
 * up the new options on next build — no parallel hardcoded copies to keep
 * in sync.
 *
 * Stored on `Vendor.category` as a free-form string column. Validation is
 * just "non-empty string" on the schema side; this list is the UI gate.
 */
export const VENDOR_CATEGORIES = [
    "Accounting & Tax",
    "Banking & Lending",
    "Benefits & HR",
    "Business Insurance",
    "Compliance",
    "Consulting",
    "Financial Planning",
    "IT & Cybersecurity",
    "Legal",
    "Marketing & Branding",
    "Payroll",
    "Real Estate",
    "Wealth Management",
    "Other",
] as const;

export type VendorCategory = (typeof VENDOR_CATEGORIES)[number];
